import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-log-hero-item',
  templateUrl: './log-hero-item.component.html',
  styleUrls: ['./log-hero-item.component.scss'],
})
export class LogHeroItemComponent implements OnInit {
  @Input() positive = true; // true shows a green check, otherwise a red cross
  @Input() pending = false;
  @Input() info = false;
  @Input() warning = false;

  constructor() { }

  ngOnInit() { }
}
